import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const HeartOutlineIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-heart-outline', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path d='M8.00002 14.4933L7.58002 14.1467C6.66414 13.3991 5.78952 12.6024 4.96002 11.76L4.82002 11.62C4.05993 10.8913 3.3578 10.1045 2.72002 9.26666C1.46668 7.50666 1.33335 5.49999 2.36668 3.99999C2.77511 3.36042 3.38392 2.87418 4.09797 2.61726C4.81202 2.36035 5.59107 2.34725 6.31335 2.57999C6.97956 2.82914 7.56349 3.25843 8.00002 3.81999C8.43655 3.25843 9.02047 2.82914 9.68668 2.57999C10.409 2.34725 11.188 2.36035 11.9021 2.61726C12.6161 2.87418 13.2249 3.36042 13.6334 3.99999C14.6734 5.48666 14.5334 7.49333 13.28 9.25333C12.6422 10.0911 11.9401 10.878 11.18 11.6067L11.04 11.7467C10.2105 12.589 9.3359 13.3858 8.42002 14.1333L8.00002 14.4933ZM5.85335 3.82666C5.66927 3.77296 5.47843 3.74602 5.28668 3.74666C4.92394 3.76657 4.57061 3.86949 4.25391 4.04748C3.93721 4.22548 3.66561 4.4738 3.46002 4.77332C2.40002 6.29332 3.46002 7.99999 3.80668 8.48666C4.41313 9.27049 5.08198 10.004 5.80668 10.68L5.94002 10.82C6.60668 11.4867 7.31335 12.1533 8.03335 12.76C8.75335 12.1533 9.45335 11.5 10.1267 10.82L10.26 10.68C10.9732 10.0027 11.6309 9.26921 12.2267 8.48666C12.5734 7.99999 13.6334 6.29332 12.5734 4.77332C12.3624 4.4749 12.0924 4.22303 11.78 4.03332C11.6223 3.94104 11.4546 3.86722 11.28 3.81332C11.1068 3.77316 10.9307 3.74642 10.7534 3.73332C10.3343 3.67448 9.90806 3.7692 9.55335 3.99999C9.23122 4.23408 8.94585 4.51495 8.70668 4.83332C8.43446 5.15263 8.20991 5.50967 8.04002 5.89332L8.00002 5.99999C7.83594 5.49342 7.55673 5.03176 7.18428 4.65121C6.81183 4.27066 6.35628 3.98159 5.85335 3.80666V3.82666Z' />
    </svg>
  );
};

export default HeartOutlineIcon;
